// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CellList-module__ui-CellList--dCySN {
  display: flex;
  width: 100%;
  box-sizing: border-box;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
}

.CellList-module__ui-CellList--dCySN > .CellList-module__content--IZRqs {
  display: flex;
  width: 100%;
  max-width: none;
  align-items: flex-start;
  gap: 8px;
  overflow: hidden;
  color: inherit;
  font-family: inherit;
  font-size: inherit;
  font-weight: inherit;
  line-height: normal;
  text-overflow: clip;
  white-space: normal;
}

.CellList-module__cell-list-title--F4C96 {
  width: 100%;
  margin: 0;
  color: var(--chaek-color-text-primary);
  font-family: var(--chaek-font-family-gowun-dodum);
  font-size: 0.875rem; /* 14px */
  font-weight: 400;
  line-height: 1.3125rem; /* 21px */
  letter-spacing: -0.1504px;
}

.CellList-module__cell-list-title--F4C96 > :last-child:not(:first-child) {
  margin-left: 4px;
}

.CellList-module__ui-CellList-Item--E8hcD {
  display: flex;
  overflow: hidden;
  min-width: 0;
  box-sizing: border-box;
  flex: 1 0 0;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 12px 8px;
  border-radius: 12px;
  background-color: var(--chaek-color-surface-subtle);
  text-align: center;
}

.CellList-module__headline--xRvRV,
.CellList-module__title--BvCs8,
.CellList-module__content--IZRqs {
  display: block;
  max-width: 100%;
  box-sizing: border-box;
}

.CellList-module__headline--xRvRV {
  display: flex;
  width: 70px;
  align-items: center;
  justify-content: center;
  gap: 4px;
  color: var(--chaek-color-text-primary);
  font-family: var(--chaek-font-family-gowun-dodum);
  font-size: 1.3125rem; /* 21px */
  font-weight: 400;
  line-height: 1.96875rem; /* 31.5px */
  letter-spacing: -1.0589px;
  white-space: nowrap;
}

.CellList-module__ratingStar--PU7Ta {
  width: 24px;
  height: 31.5px;
  flex: 0 0 24px;
  background-size: 22px 22px;
}

.CellList-module__title--BvCs8 {
  display: -webkit-box;
  width: 100%;
  min-height: 42px;
  overflow: hidden;
  color: var(--chaek-color-text-primary);
  font-size: 0.875rem; /* 14px */
  line-height: 1.3125rem; /* 21px */
  letter-spacing: -0.1504px;
  overflow-wrap: anywhere;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.CellList-module__content--IZRqs {
  overflow: hidden;
  color: var(--chaek-color-text-placeholder);
  font-size: 0.625rem; /* 10px */
  line-height: normal;
  text-overflow: ellipsis;
  white-space: nowrap;
}
`, "",{"version":3,"sources":["webpack://./../../packages/design-system/src/components/CellList/CellList.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,WAAW;EACX,sBAAsB;EACtB,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,WAAW;EACX,eAAe;EACf,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,SAAS;EACT,sCAAsC;EACtC,iDAAiD;EACjD,mBAAmB,EAAE,SAAS;EAC9B,gBAAgB;EAChB,sBAAsB,EAAE,SAAS;EACjC,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;EACtB,WAAW;EACX,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,mDAAmD;EACnD,kBAAkB;AACpB;;AAEA;;;EAGE,cAAc;EACd,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,sCAAsC;EACtC,iDAAiD;EACjD,oBAAoB,EAAE,SAAS;EAC/B,gBAAgB;EAChB,uBAAuB,EAAE,WAAW;EACpC,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,sCAAsC;EACtC,mBAAmB,EAAE,SAAS;EAC9B,sBAAsB,EAAE,SAAS;EACjC,yBAAyB;EACzB,uBAAuB;EACvB,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,0CAA0C;EAC1C,mBAAmB,EAAE,SAAS;EAC9B,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB","sourcesContent":[".ui-CellList {\n  display: flex;\n  width: 100%;\n  box-sizing: border-box;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 12px;\n}\n\n.ui-CellList > .content {\n  display: flex;\n  width: 100%;\n  max-width: none;\n  align-items: flex-start;\n  gap: 8px;\n  overflow: hidden;\n  color: inherit;\n  font-family: inherit;\n  font-size: inherit;\n  font-weight: inherit;\n  line-height: normal;\n  text-overflow: clip;\n  white-space: normal;\n}\n\n.cell-list-title {\n  width: 100%;\n  margin: 0;\n  color: var(--chaek-color-text-primary);\n  font-family: var(--chaek-font-family-gowun-dodum);\n  font-size: 0.875rem; /* 14px */\n  font-weight: 400;\n  line-height: 1.3125rem; /* 21px */\n  letter-spacing: -0.1504px;\n}\n\n.cell-list-title > :last-child:not(:first-child) {\n  margin-left: 4px;\n}\n\n.ui-CellList-Item {\n  display: flex;\n  overflow: hidden;\n  min-width: 0;\n  box-sizing: border-box;\n  flex: 1 0 0;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  padding: 12px 8px;\n  border-radius: 12px;\n  background-color: var(--chaek-color-surface-subtle);\n  text-align: center;\n}\n\n.headline,\n.title,\n.content {\n  display: block;\n  max-width: 100%;\n  box-sizing: border-box;\n}\n\n.headline {\n  display: flex;\n  width: 70px;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n  color: var(--chaek-color-text-primary);\n  font-family: var(--chaek-font-family-gowun-dodum);\n  font-size: 1.3125rem; /* 21px */\n  font-weight: 400;\n  line-height: 1.96875rem; /* 31.5px */\n  letter-spacing: -1.0589px;\n  white-space: nowrap;\n}\n\n.ratingStar {\n  width: 24px;\n  height: 31.5px;\n  flex: 0 0 24px;\n  background-size: 22px 22px;\n}\n\n.title {\n  display: -webkit-box;\n  width: 100%;\n  min-height: 42px;\n  overflow: hidden;\n  color: var(--chaek-color-text-primary);\n  font-size: 0.875rem; /* 14px */\n  line-height: 1.3125rem; /* 21px */\n  letter-spacing: -0.1504px;\n  overflow-wrap: anywhere;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 2;\n}\n\n.content {\n  overflow: hidden;\n  color: var(--chaek-color-text-placeholder);\n  font-size: 0.625rem; /* 10px */\n  line-height: normal;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ui-CellList": `CellList-module__ui-CellList--dCySN`,
	"content": `CellList-module__content--IZRqs`,
	"cell-list-title": `CellList-module__cell-list-title--F4C96`,
	"ui-CellList-Item": `CellList-module__ui-CellList-Item--E8hcD`,
	"headline": `CellList-module__headline--xRvRV`,
	"title": `CellList-module__title--BvCs8`,
	"ratingStar": `CellList-module__ratingStar--PU7Ta`
};
export default ___CSS_LOADER_EXPORT___;
